<template>
  <label
    :class="{
      'oai-IntervalCard-selected': isSelected
    }"
    class="oai-IntervalCard"
  >
    <input
      v-model="model"
      :name="name"
      :value="value"
      class="oai-IntervalCard_Input"
      hidden
      type="radio"
    />

    <span aria-hidden="true" class="oai-IntervalCard_OptionCircle">
      <span
        :class="{
          'oai-IntervalCard_OptionCircleInner-selected': isSelected
        }"
        class="oai-IntervalCard_OptionCircleInner"
      >
        <span v-if="isSelected" class="oai-IntervalCard_OptionCircleDot" />
      </span>
    </span>

    <span class="oai-IntervalCard_Body">
      <span class="oai-IntervalCard_Title">{{ option.title }}</span>
      <span class="oai-IntervalCard_Description">{{ option.description }}</span>
    </span>
  </label>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({
  name: 'OnboardingAiIntervalOptionCard'
})

const props = defineProps({
  /**
   * @type {Object}
   * @property {string} id
   * @property {string} title
   * @property {string} description
   */
  option: {
    type: Object,
    required: true
  },

  value: {
    type: String,
    required: true
  },

  name: {
    type: String,
    required: true
  }
})

const model = defineModel({ type: String })

const isSelected = computed(() => model.value === props.value)
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/onboarding-ai-step';

.oai-IntervalCard {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 24px;
  border: 1px solid $grey-2-next;
  border-radius: $border-radius-lg;
  background: $white;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &:hover:not(&-selected) {
    border-color: $grey-1-next;
  }

  &-selected {
    border: 1px solid $oai-bg;
    background: $oai-bg;
  }
}

.oai-IntervalCard_Input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.oai-IntervalCard_OptionCircle {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.oai-IntervalCard_OptionCircleInner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 2px solid $oai-radio-border;
  border-radius: 50%;
  background: $white;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &-selected {
    border-color: $primary-color-next;
    background: $primary-color-next;
  }
}

.oai-IntervalCard_OptionCircleDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: $white;
}

.oai-IntervalCard_Body {
  display: grid;
  gap: 6px;
  min-width: 0;
  flex: 1;
}

.oai-IntervalCard_Title {
  font-size: $fs-14;
  line-height: 20px;
  font-weight: fw('semi-bold');
  color: $oai-title-default;

  .oai-IntervalCard-selected & {
    color: $oai-title-selected;
  }
}

.oai-IntervalCard_Description {
  font-size: $fs-12;
  line-height: 18px;
  font-weight: fw('regular');
}
</style>
